// extracted by mini-css-extract-plugin
module.exports = {"black":"styles_black__chH6v"};